<template>
    <div>
        <template v-if="company === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> InActive Companies ({{inactive_count}})</h1>
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
					<table id="companyTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Payment Engine</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
			</div>
        </template>
        <template v-else-if="company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                company: null,
                company_restore: null,
                dtActive : null,
                inactive_count : 0,
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('company|company_restore').then(result => {
                this.company = result.company;
                this.company_restore = result.company_restore;
            }).then(result => {
                if(this.company == true){
                    this.inactiveCompanies();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            inactiveCompanies(){
                var self = this;
                this.dtActive = $('#companyTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listCompanies",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": 'records',
                        "data": function ( d ) {
                            d.tab = 'inactive';
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'payment_engine'},
                        {data: 'phone'},
                        {data: 'email'},
                        {data: 'address_1'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editCompany/'+full['id'];
                            var restore_button = '';
                            if (self.company_restore === true){
                                restore_button = '<a href="javascript:void(0);" onclick="VueComponents.inactivecompaniesComponent.methods.restoreCompany('+full['id']+')" class="action edit"><i class="fas fa-trash-restore"></i></a>';
                            }
                            return restore_button

                            // return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a> | <a href="javascript:void(0);" onclick="VueComponents.inactivecompaniesComponent.methods.restoreCompany('+full['id']+')" class="action edit"><i class="fas fa-trash-restore"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 5 ]
                    }],
                    "initComplete": (settings, json) => { this.inactive_count = json.recordsTotal; this.$Progress.finish();}
                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        gThat.dtActive.search(this.value).draw();
                    }
                });
            },
            restoreCompany(id){
                var that = this;
               gThat.$Progress.start();
               swal.fire({
                    title: 'Are you sure?',
                    text: "You want to restore this company !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, restore it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get("/api/softDeleteCompanyRestore/"+id)
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.status == 200){
                                    gThat.$Progress.finish();
                                    gThat.dtActive.ajax.reload( json => {
                                        gThat.inactive_count = json.recordsTotal;
                                    }, false);
                                    gThat.showAlertBox('success','Company restored successfully.');
                                }else{
                                    gThat.showToastBox('error','System is not responding! Please try again later.');
                                }
                            }else{
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error','System is not responding! Please try again later.');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error','System is not responding! Please try again later.');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                });
            }
            
        },

    }
</script>
